/* eslint-disable complexity */
import { QuotaCleanerType } from 'reactApp/types/QuotaCleaner';

export interface QuotaCleanerFeaturesConfig {
    quotaCleanerWeb: boolean;
    quotaCleanerMob: boolean;
    quotaCleanerCloud: boolean;
    quotaCleanerLetters: boolean;
    quotaCleanerGroups: string[];

    quotaCleanerForPaid: boolean;
    quotaCleanerFastEnable: boolean;
    quotaCleanerFastEnableMob: boolean;
    quotaCleanerFastGroupsByPriority: string[];
    quotaCleanerByLink: boolean;
}

export interface QuotaCleanerShowParams {
    isMobile: boolean;
    isAnonymous: boolean;
    isPaid: boolean;
    isCorp: boolean;
    isBiz: boolean;
    isQuotaGroupsLoadingError: boolean;
    isAllLoadedEmpty: boolean;
    canFastClean: boolean;
    isFromAction: boolean;
    isFromMail: boolean;
}

/**
 * Определяет, какую чистилку показываем на основе фичей и параметров среды
 * @param features
 * @param params
 * @returns тип чистилки
 */
export const resolveQuotaCleanerType = (features: QuotaCleanerFeaturesConfig, params: QuotaCleanerShowParams): QuotaCleanerType | null => {
    const {
        isMobile,
        isAnonymous,
        isPaid,
        isCorp,
        isBiz,
        isQuotaGroupsLoadingError,
        isAllLoadedEmpty,
        canFastClean,
        isFromAction,
        isFromMail,
    } = params;
    const {
        quotaCleanerWeb,
        quotaCleanerMob,
        quotaCleanerCloud,
        quotaCleanerLetters,

        quotaCleanerForPaid,
        quotaCleanerGroups,
        quotaCleanerFastEnable,
        quotaCleanerFastEnableMob,
        quotaCleanerFastGroupsByPriority,
        quotaCleanerByLink,
    } = features;

    if (isQuotaGroupsLoadingError || isAnonymous) {
        return null;
    }

    // резолвим доступность быстрой чистилки
    const isFastCleanerEnabledAsFeature = isMobile ? quotaCleanerFastEnableMob : quotaCleanerFastEnable;
    const isAnyFastCleanerGroupOn = !!quotaCleanerFastGroupsByPriority.length;

    // быстрая чистилка: включена фичами, включена хоть одна группа фичами и есть что чистить
    const isFastCleanerAvailable = isFastCleanerEnabledAsFeature && isAnyFastCleanerGroupOn && canFastClean;

    // резолвим доступность обычный чистилки
    let isBaseCleanerEnabledAsFeature = !isMobile ? quotaCleanerWeb : quotaCleanerMob;

    if (isPaid || isCorp || isBiz) {
        isBaseCleanerEnabledAsFeature = quotaCleanerForPaid || isBaseCleanerEnabledAsFeature;
    }

    // насильно включаем, если юзер пришел по ссылке с action=quota-cleaner
    if (isFromAction) {
        isBaseCleanerEnabledAsFeature = quotaCleanerByLink || isBaseCleanerEnabledAsFeature;
    }
    // корнер-кейс – включена только быстрая чистилка, но она недоступна, а юзер пришел из СТА в почте –
    // показываем хотя бы обычную чистилку
    if (isFastCleanerEnabledAsFeature && !isFastCleanerAvailable && isFromMail) {
        isBaseCleanerEnabledAsFeature = true;
    }

    const isAnyBaseCleanerGroupOn = (quotaCleanerCloud || quotaCleanerLetters) && !!quotaCleanerGroups.length;

    // обычная чистилка: включена фичами, включена хоть одна группа фичами и есть что чистить
    const isBaseCleanerAvailable = isBaseCleanerEnabledAsFeature && isAnyBaseCleanerGroupOn && !isAllLoadedEmpty;

    if (isBaseCleanerAvailable && isFastCleanerAvailable) {
        return QuotaCleanerType.full;
    }

    if (isFastCleanerAvailable) {
        return QuotaCleanerType.fast;
    }

    if (isBaseCleanerAvailable) {
        return QuotaCleanerType.base;
    }

    return null;
};
